import React from "react";
import "../../../css/MonthAll.css";
import mobility from "../../../img/ride.png";

interface MonthAllProps {
  ThisMonth: number;
  LastMonth: number;
}

const MonthAll = ({ ThisMonth, LastMonth }: MonthAllProps) => {
  return (
    <div className="month_ride_container">
      <div className="month_ride_display">
        <img className="mobility" src={mobility} />
        <div className="month_ride_title">今月のライド金額</div>
      </div>
      <div className="month_ride_of">
        {ThisMonth.toLocaleString()} <span className="unit">円</span>
      </div>
      <div className="month_ride_last_month">
        先月のライド金額:
        <span className="month_ride_last_number">
          {LastMonth.toLocaleString()}
          <span className="unit">円</span>
        </span>
      </div>
    </div>
  );
};

export default MonthAll;
